function useIsKarmaEarnShown() {
  return true;
}

export default useIsKarmaEarnShown;
